import { reducers } from "components/administration/designManager/themeSlice";
import { createSlice } from "@reduxjs/toolkit";

const groupThemeSlice = createSlice({
  name: "groupTheme",
  initialState: {},
  reducers: {
    ...reducers({ override: false }),
    resetTheme() {
      return {};
    },
  },
});

export const {
  setTheme,
  resetTheme,
  setBannerImage,
  setLogoImage,
  changeColor,
  setHeaderVariant,
} = groupThemeSlice.actions;
export default groupThemeSlice.reducer;
